import {setOrFallbackValue} from './helper';
import CartItem from './cart_item';
import ShippingAddress from './shipping_address';
export default class Cart {
    constructor(properties) {
        this.items = ('' === setOrFallbackValue(properties, 'items', '')) ?
            [] : properties.items.map((item) => {return new CartItem(item);});
        this.shippingAddress = ('' === setOrFallbackValue(properties, 'shippingAddress', '')) ?
            [] : new ShippingAddress(properties.shippingAddress);
    }
}
